import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { EagerLoaded } from "../../common/types/base/orm";
import { Invoice } from "../../common/types/invoice";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "../general/Modal/Modal";
import { InvoiceFilters } from "../../common/contracts/invoice.contract";
import { PaginatedInvoicesTableContextProvider } from "./PaginatedInvoicesTableContextProvider";
import { InvoicesTableContainer } from "./InvoicesTableContainer";
import { InvoiceDetails } from "./InvoiceDetails";
import styles from "./InvoicesDrilldownModal.module.scss";

interface InvoicesDrilldownModalProps {
    show: boolean;
    onHide: () => void;
    filters?: InvoiceFilters;
}

export const InvoicesDrilldownModal: React.FC<InvoicesDrilldownModalProps> = ({
    show,
    onHide,
    filters,
}) => {
    const [selectedInvoice, setSelectedInvoice] = useState<Invoice>();

    useEffect(() => {
        if (filters) {
            setSelectedInvoice(undefined);
        }
    }, [filters]);

    return (
        <StandardModal
            show={show}
            onHide={onHide}
            size="xl"
            className={styles.invoicesDrilldownModal}
        >
            <StandardModalHeader>Invoices</StandardModalHeader>
            <StandardModalBody>
                <PaginatedInvoicesTableContextProvider overlayFilters={filters}>
                    <Row>
                        <Col sm={12} md={selectedInvoice ? 8 : 12}>
                            <InvoicesTableContainer
                                onInvoiceClick={setSelectedInvoice}
                                selectedInvoiceId={selectedInvoice?.id}
                            />
                        </Col>
                        {selectedInvoice && (
                            <Col md={4} className="d-none d-md-block">
                                <InvoiceDetails
                                    invoice={
                                        selectedInvoice as EagerLoaded<
                                            Invoice,
                                            "lines"
                                        >
                                    }
                                    setInvoice={setSelectedInvoice}
                                    hideCloseButton
                                    className={styles.invoiceDetails}
                                />
                            </Col>
                        )}
                    </Row>
                </PaginatedInvoicesTableContextProvider>
            </StandardModalBody>
        </StandardModal>
    );
};
